import UserUsecase from "@/usecases/user.usecase.js";
import FileUsecase from "@/usecases/file.usecase.js";
import OrderUsecase from "@/usecases/order.usecase.js";
import ProductUsecase from "@/usecases/product.usecase.js";
import MessageUsecase from "@/usecases/message.usecase.js";
import OrderNoteUsecase from "@/usecases/orderNote.usecase.js";
import NotificationUsecase from "@/usecases/notification.usecase.js";
import VariantCharacterGroupUsecase from "@/usecases/variantCharacterGroup.usecase.js";
import VariantCharacterUsecase from "@/usecases/variantCharacter.usecase.js";
import FavoriteVariantCharactersUsecase from "@/usecases/favoriteVariantCharacters.usecase.js";
import DefaultExpectedShippingDateUsecase from "@/usecases/defaultExpectedShippingDate.usecase.js";

const classes = {
  user: UserUsecase,
  file: FileUsecase,
  order: OrderUsecase,
  product: ProductUsecase,
  message: MessageUsecase,
  orderNote: OrderNoteUsecase,
  notification: NotificationUsecase,
  variantCharacterGroup: VariantCharacterGroupUsecase,
  variantCharacter: VariantCharacterUsecase,
  favoriteVariantCharacters: FavoriteVariantCharactersUsecase,
  defaultExpectedShippingDate: DefaultExpectedShippingDateUsecase,
};

export default class UsecaseFactory {
  static create (name) {
    return new classes[name]();
  }
}
